import React from 'react';
import styles from './HeaderListCohortListExpandableListItem.module.scss';
import { Arrow } from './Arrow';

interface IHeaderListCohortListExpandableListItem {
  active: boolean;
  description: string;
  DynamicLink?: any;
  label: string;
  linkProps: object;
  hideBorder?: boolean;
}

export const HeaderListCohortListExpandableListItem = ({
  active,
  description,
  DynamicLink = 'a',
  label,
  linkProps,
  hideBorder = false,
}: IHeaderListCohortListExpandableListItem) => {
  const className = [styles.root];
  if (active) {
    className.push(styles.active);
  }
  if (hideBorder) {
    className.push(styles.hideBorder);
  }

  return (
    <li className={className.join(' ')} role="menuitem">
      <DynamicLink className={styles.link} {...linkProps}>
        <span className={styles.title}>
          <span className={styles.label}>{label}</span>
          <span className={styles.arrow}>
            <Arrow direction="right" color="currentColor" />
          </span>
        </span>
        <span className={styles.description} aria-hidden="true">
          {description}
        </span>
      </DynamicLink>
    </li>
  );
};
